import dayjs from 'dayjs'

function dateFormat (value, format = 'YYYY-MM-DD') {
  return dayjs(value).format(format)
}

function dateToNow (value) {
  var relativeTime = require('dayjs/plugin/relativeTime')
  dayjs.extend(relativeTime)
}

function secondToDate (seconds) {
  return new Date(seconds * 1000).toISOString().substr(11, 8)
}

export {
  dateFormat,
  dateToNow,
  secondToDate
}
